import axios from '@/axios';

// URL and endpoint constants
const EXPERIMENTS_PARAM_URL = '/experiments_parameters';
const INDEX_URL = '/building_blocks';
const EXPERIMENTS_URL = '/experiments';

export default {
  index(succ) {
    axios.get(EXPERIMENTS_PARAM_URL)
      .then((response) => { succ(response); });
  },
  getBlocks(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response); });
  },
  createExperiments(experiment, succ) {
    axios.post(EXPERIMENTS_URL, experiment)
      .then((response) => { succ(response); });
  },
  updateExperiments(experiment, id) {
    axios.patch(`${EXPERIMENTS_URL}/${id}`, experiment)
      .then(() => { location.href = '/report_my_results'; });
  },
  getProtocol(id, succ) {
    axios.get(`${EXPERIMENTS_URL}/${id}/generate_protocol`)
      .then((response) => { succ(response); });
  },
  getExperimentsList(succ) {
    axios.get(EXPERIMENTS_URL)
      .then((response) => { succ(response); });
  },
  getExperiment(id, succ) {
    axios.get(`${EXPERIMENTS_URL}/${id}/`)
      .then((response) => { succ(response); });
  },
  saveResults(id, photos, deletePhotos, wells) {
    axios.post(`${EXPERIMENTS_URL}/${id}/add_results`, { id, photos, delete_photos: deletePhotos, wells })
      .then(() => {
        location.href = '/prev_results';
      });
  },
  getSummary(id, succ) {
    axios.get(`${EXPERIMENTS_URL}/${id}/generate_xlsx`, {
      responseType: 'blob',
    })
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/game.js